export default function isFunction(functionName) {
  return functionName && {}.toString.call(functionName) === '[object Function]';
}
